export class EnumHelper{

}